import { ContactLink, LegalPage, type LegalSection } from './LegalPage';

const STRAVA_TERMS = 'https://www.strava.com/legal/terms';

export const TERMS_SECTIONS: readonly LegalSection[] = [
  {
    title: 'About these terms',
    blocks: [
      'PainPal is run by Donovan Crewe. These terms apply when you create an account or use PainPal. If you do not agree with them, please do not use PainPal.',
    ],
  },
  {
    title: 'Personal use',
    blocks: [
      'PainPal is for your own training, for personal and non-commercial use. Do not resell it, run it for other people as a business, or scrape it. Your own data is yours to take with you (see the Privacy Policy).',
      'You must be 16 or older, give accurate details and keep your password to yourself.',
    ],
  },
  {
    title: 'Your data',
    blocks: [
      'Your activities and settings stay yours. You let PainPal store and process them to provide the service, as the Privacy Policy describes.',
    ],
  },
  {
    title: 'Strava',
    blocks: [
      <>
        Connecting Strava is optional. Data that comes from Strava is also subject to{' '}
        <a href={STRAVA_TERMS} target="_blank" rel="noopener">Strava’s terms</a>. PainPal is not developed, sponsored or endorsed by Strava.
      </>,
      'When Strava access ends, PainPal deletes the activities it imported from Strava.',
    ],
  },
  {
    title: 'Not medical advice',
    blocks: [
      'Load, Intensity, Fitness, Fatigue, Form and zones are estimates worked out from your recordings and the thresholds you set. They can be wrong, and they are not medical advice. Talk to a doctor before you start or change training, and train at your own risk.',
    ],
  },
  {
    title: 'Provided as is',
    blocks: [
      'PainPal is provided as is and as available, without any promise that it will be accurate, uninterrupted or free of errors. It may change, pause or stop. Keep your own copies of anything you cannot afford to lose.',
    ],
  },
  {
    title: 'Limitation of liability',
    blocks: [
      'As far as the law allows, PainPal and Donovan Crewe are not liable for any indirect or consequential loss, for lost data, or for any loss or injury that follows from training decisions based on PainPal’s numbers. Nothing in these terms limits liability that the law does not allow to be limited.',
    ],
  },
  {
    title: 'Fair use',
    blocks: [
      'Do not try to break, overload or get around PainPal’s security, reach other people’s data, or upload harmful files. PainPal may suspend or close an account that does.',
    ],
  },
  {
    title: 'Stopping',
    blocks: ['You can stop at any time by deleting your account in Settings. That deletes your account and all its data.'],
  },
  {
    title: 'Changes to these terms',
    blocks: [
      'We post any change on this page with a new effective date. Using PainPal after a change means you accept the new terms.',
      <>Questions: <ContactLink />.</>,
    ],
  },
];

export function TermsPage() {
  return <LegalPage title="TERMS" sections={TERMS_SECTIONS} />;
}
